export enum ButtonNormalTheme {
	Normal = 'normal',
	Light = 'light',
	Social = 'social',
	NaturalMedium = 'natural-medium',
	NaturalLarge = 'natural-large',
	Revamp = 'revamp',
}

export enum ButtonOutlineTheme {
	Normal = '',
	Social = 'social',
	NaturalMedium = 'natural-medium',
	NaturalLarge = 'natural-large',
	Revamp = 'revamp',
}

export enum ButtonSize {
	Large = 'large',
	Medium = 'medium',
	Small = 'small',
}

export enum RippleTheme {
	Dark,
	Light,
}
